import React from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { FormGroup, Label } from 'reactstrap';

const StartEndDatePicker = ({ handleStartEndDate, startDate, endDate }) => {
  const onStartSelect = (startDateValue) => {
    let tempEnd = endDate;
    if (startDateValue > tempEnd) {
      tempEnd = startDateValue;
    }
    handleStartEndDate(startDateValue, tempEnd);
  };

  const onEndSelect = (endDateValue) => {
    let tempStart = startDate;
    if (endDateValue < tempStart) {
      tempStart = endDateValue;
    }
    handleStartEndDate(tempStart, endDateValue);
  };

  return (
    <FormGroup className="d-flex justify-content-around">
      <div className="w-100">
        <Label for="formStartDate" className="text-gray font-weight-bold">
          Start Date
        </Label>
        <DatePicker
          className="form-control"
          selected={startDate}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MMM/yyy"
          onChange={onStartSelect}
          showMonthYearDropdown
          minDate={moment().subtract(24, 'months').toDate()}
          maxDate={moment().add(24, 'months').toDate()}
        />
      </div>
      <div className="w-100">
        <Label for="formEndDate" className="text-gray font-weight-bold">
          End Date
        </Label>
        <DatePicker
          className="form-control"
          selected={endDate}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MMM/yyy"
          onChange={onEndSelect}
          showMonthYearDropdown
          minDate={moment().subtract(24, 'months').toDate()}
          maxDate={moment().add(24, 'months').toDate()}
        />
      </div>
    </FormGroup>
  );
};

export default StartEndDatePicker;
